// Misc
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

// Validation
import { Validator } from 'react-vld'
import { validateNumber, validateRange } from 'utils/validation'

// Atoms
import TextInput from 'atoms/TextInput'

const formatNumber = (value) => {
  return parseFloat(value.replace(/,/g, ''))
}

class NumberInput extends PureComponent {
  static propTypes = {
    defaultValue: PropTypes.number,
    onSave: PropTypes.func,
  }

  static defaultProps = {
    onSave: () => {},
  }

  handleSave = (value) => {
    const { onSave } = this.props
    onSave(formatNumber(value), value)
  }

  render() {
    const { defaultValue: propDefaultValue, onSave, ...rest } = this.props
    const defaultValue = !Number.isNaN(parseFloat(propDefaultValue)) ? propDefaultValue.toString() : ''
    return (
      <TextInput
        {...rest}
        defaultValue={defaultValue}
        onSave={this.handleSave}
      />
    )
  }
}

export default class NumberInputValidator extends PureComponent { // eslint-disable-line
  static propTypes = {
    validation: PropTypes.object,
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
    innerRef: PropTypes.func,
  }

  static defaultProps = {
    innerRef: () => {},
    minValue: -Infinity,
    maxValue: Infinity,
  }

  validate = () => {
    const { minValue, maxValue } = this.props
    const { value } = this.textInput.state
    validateNumber(value, 'Invalid number')
    validateRange(value, minValue, maxValue, 'Invalid value')
  }

  innerRef = (component) => {
    const { innerRef } = this.props
    this.textInput = component
    innerRef(component)
  }

  render() {
    const { validation, minValue, maxValue, innerRef, ...rest } = this.props
    return (
      <Validator rule={this.validate}>
        { innerValidation => (
          <NumberInput
            {...rest}
            validation={validation || innerValidation}
            innerRef={this.innerRef}
          />
        ) }
      </Validator>
    )
  }
}
